import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";

function ImgModal(props) {
  // Initialize state with default values for accountName, accountNo, and status

  // useEffect(() => {
  //   getApiDataService(SUB_CATEGORY_API(mainStatus)).then((res) => {
  //     // console.log(res.data, "response");
  //     setStatus(res.data);
  //   });
  // }, [mainStatus]);

  return (
    <Modal
      isOpen={props.imgModal}
      toggle={props.onClose}
      style={{ width: "fit-content" }}
    >
      <button
        onClick={props.onClose}
        style={{
          border: "none",
          background: "transparent",
          position: "absolute",
          right: "-40px",
          fontSize: "30px",
          top: "-28px",
          color: "white",
          fontWeight: "bold",
        }}
      >
        X
      </button>
      <img src={props.img} alt="" style={{ width: "400px", height: "550px" }} />
    </Modal>
  );
}

export default ImgModal;
